import Vue from 'vue'
import Vuex from 'vuex'
import { company } from './company'
import { alert } from './alert'
import { user } from './user'

Vue.use(Vuex)

export declare interface RootState {
  dummy?: string;  // Just a dummy interface because we don't have root state yet
}

export default new Vuex.Store({
  modules: {
    company,
    alert,
    user,
  }
})
